import type { ValueOf } from 'type-fest';

import type { Category } from './common';

export const PACKAGE_SORT = {
  ASC: 'package_asc',
  DESC: 'package_desc',
} as const;

export type PackageSort = ValueOf<typeof PACKAGE_SORT>;

export const SEVERITY_SORT = {
  ASC: 'severity_asc',
  DESC: 'severity_desc',
} as const;

export type SeveritySort = ValueOf<typeof SEVERITY_SORT>;

export const CREATED_AT_SORT = {
  ASC: 'created_at_asc',
  DESC: 'created_at_desc',
} as const;

export type CreatedAtSort = ValueOf<typeof CREATED_AT_SORT>;

export const ISSUE_COUNT_SORT = {
  ASC: 'issue_count_asc',
  DESC: 'issue_count_desc',
} as const;

export type IssueCountSort = ValueOf<typeof ISSUE_COUNT_SORT>;

export const ISSUE_TYPE_SORT = 'issue_type';
export type IssueTypeSort = typeof ISSUE_TYPE_SORT;

export const EPSS_SORT = {
  ASC: 'epss_asc',
  DESC: 'epss_desc',
} as const;

export type EpssSort = ValueOf<typeof EPSS_SORT>;

export type AnyIssueSort = PackageSort | SeveritySort | CreatedAtSort | EpssSort;
export type AnyIssueRevisionSort = PackageSort | IssueCountSort | CreatedAtSort | EpssSort;
export type AnySort = AnyIssueSort | AnyIssueRevisionSort;

export type CommonIssueSort = PackageSort | CreatedAtSort | IssueTypeSort;
export type LicensingIssueSort = CommonIssueSort;
export type QualityIssueSort = CommonIssueSort;
export type VulnIssueSort = CommonIssueSort | SeveritySort | EpssSort;

export type CommonIssueRevisionSort = PackageSort | CreatedAtSort | IssueCountSort;
export type LicensingIssueRevisionSort = CommonIssueRevisionSort;
export type QualityIssueRevisionSort = CommonIssueRevisionSort;
export type VulnIssueRevisionSort = CommonIssueRevisionSort;

export const ISSUE_SORT_OPTION_BY_CATEGORY: Readonly<Record<Category, AnySort[]>> = Object.freeze({
  licensing: [
    CREATED_AT_SORT.DESC,
    CREATED_AT_SORT.ASC,
    PACKAGE_SORT.ASC,
    PACKAGE_SORT.DESC,
  ],
  vulnerability: [
    SEVERITY_SORT.DESC,
    SEVERITY_SORT.ASC,
    EPSS_SORT.DESC,
    EPSS_SORT.ASC,
    CREATED_AT_SORT.DESC,
    CREATED_AT_SORT.ASC,
    PACKAGE_SORT.ASC,
    PACKAGE_SORT.DESC,
  ],
  quality: [
    CREATED_AT_SORT.DESC,
    CREATED_AT_SORT.ASC,
    PACKAGE_SORT.ASC,
    PACKAGE_SORT.DESC,
  ],
});

export const REVISION_SORT_OPTION_BY_CATEGORY: Readonly<Record<Category, AnySort[]>> = Object.freeze({
  licensing: [
    ISSUE_COUNT_SORT.DESC,
    ISSUE_COUNT_SORT.ASC,
    CREATED_AT_SORT.DESC,
    CREATED_AT_SORT.ASC,
    PACKAGE_SORT.ASC,
    PACKAGE_SORT.DESC,
  ],
  vulnerability: [
    ISSUE_COUNT_SORT.DESC,
    ISSUE_COUNT_SORT.ASC,
    CREATED_AT_SORT.DESC,
    CREATED_AT_SORT.ASC,
    PACKAGE_SORT.ASC,
    PACKAGE_SORT.DESC,
  ],
  quality: [
    ISSUE_COUNT_SORT.DESC,
    ISSUE_COUNT_SORT.ASC,
    CREATED_AT_SORT.DESC,
    CREATED_AT_SORT.ASC,
    PACKAGE_SORT.ASC,
    PACKAGE_SORT.DESC,
  ],
});

export const ISSUE_EXCEPTION_ID_SORT = 'id' as const;

export const ISSUE_EXCEPTION_PACKAGE_SORT = 'package' as const;

export const ISSUE_EXCEPTION_CREATED_BY_SORT = 'created_by' as const;

// Ignore scope: project, project and release groups, release group, policy, organization
export const ISSUE_EXCEPTION_SCOPE_SORT = 'scope' as const;

export type IssueExceptionSort =
  | typeof ISSUE_EXCEPTION_ID_SORT
  | typeof ISSUE_EXCEPTION_PACKAGE_SORT
  | typeof ISSUE_EXCEPTION_CREATED_BY_SORT
  | typeof ISSUE_EXCEPTION_SCOPE_SORT;

export type IssueExceptionOrderBy = 'asc' | 'desc';
